import {Injectable} from '@angular/core';
import {AbstractProgramService} from './abstract-program.service';
import {CreateProgramSessionDto, ProgramSessionDto, UpdateProgramSessionDto} from "@shared/dto";

@Injectable({
  providedIn: 'root'
})
export class ProgramSessionService extends AbstractProgramService<ProgramSessionDto, CreateProgramSessionDto, UpdateProgramSessionDto> {
  override get endpoint(): string {
    return `${this.api$.value}/:programId/sessions/:sessionId`;
  }
}
